import { render, staticRenderFns } from "./TransferManage.vue?vue&type=template&id=8b049da4&scoped=true&"
import script from "./TransferManage.vue?vue&type=script&lang=js&"
export * from "./TransferManage.vue?vue&type=script&lang=js&"
import style0 from "./TransferManage.vue?vue&type=style&index=0&id=8b049da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b049da4",
  null
  
)

export default component.exports